import type { RecordingEntrySurface } from '@heidi/plugin-rpa';

import { RECORDER_ENTRY_SURFACE } from '@/app-shell/rpa/recorder/lib/recording-entry-surface';

// eslint-disable-next-line @heidi/rules/no-new-cache-key-declaration -- localStorage key for the armed recording entry surface, not a cache identity
// UNCARVED DOMAIN KEY (rpa, AGE-765): rpa has no workspace package; this is durable UI state, not a query cache identity
const ENTRY_SURFACE_STORAGE_KEY = 'rpa-recorder:entry-surface';

/**
 * Durably records which window a recording was armed from, so the stop-time
 * naming prompt can be routed to the correct surface. Mirrors the
 * `canUseWindow` + try/catch guard used by `recording-stop-decisions.ts`.
 */
export function writeRecordingEntrySurface(surface: RecordingEntrySurface): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(ENTRY_SURFACE_STORAGE_KEY, surface);
  } catch {
    // Incognito / quota — the surface won't persist, so naming falls back to
    // the overlay (legacy behavior).
  }
}

export function readRecordingEntrySurface(): RecordingEntrySurface | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(ENTRY_SURFACE_STORAGE_KEY);
    if (raw === RECORDER_ENTRY_SURFACE.OVERLAY) return 'overlay';
    if (raw === RECORDER_ENTRY_SURFACE.DESKTOP_APP) return 'desktopApp';
    return null;
  } catch {
    return null;
  }
}
